import React from 'react';
import GenericDialog from "../../common/GenericDialog";

const ClassRollDialog = ({ isOpen, onClose, dialog, selectedClass, dialogTypes }) => {
    const allClasses = dialog?.type === dialogTypes?.printAllClasses;

    const handlePDF = () => {
        return new Promise(resolve => {
            printClasses('PDF', selectedClass ? selectedClass.classId : undefined);
            onClose();
            resolve();
        });
    };

    const handleExcel = () => {
        return new Promise(resolve => {
            printClasses('XLS', selectedClass ? selectedClass.classId : undefined);
            onClose();
            resolve();
        });
    };


    function printClasses(reportFormat, classId) {
        const url = '/usersCommon/printStudentList.action';
        const singleClass = classId !== undefined ? '&classId=' + classId : '';
        const urlWithParams = url + `?${singleClass}&reportFormat=${reportFormat}`;
        const printWindow = window.open(urlWithParams, 'studentListReport');
        printWindow.focus();
    }

    const title = allClasses ? 'Print All Classes' : 'Print Class';

    return (
        <GenericDialog
            title={title}
            open={isOpen}
            dialogWidth={500}
            onClose={onClose}
            buttons={[
                {
                    name: 'PDF',
                    callback: handlePDF
                },
                {
                    name: 'Excel',
                    callback: handleExcel
                },
                {
                    name: 'Cancel',
                    extraProps: { type: 'text' },
                    onClick: onClose
                }
            ]}
        >
            Please choose the export format, either PDF or Excel.
        </GenericDialog>
    );
};

export default ClassRollDialog;